import React from "react";

import messageMap from "Utilities/MessageMaps";

import {SUB_HEADER, DESCRIPTION, SOURCE, SOURCE_HEADER} from "assets/topicArticles/articleConstants";

import thumbnailAsset from "assets/topicArticles/LearningOptimizations/wellBeing/thumbnailBreak.jpg";
import stressStagesAsset from "assets/topicArticles/LearningOptimizations/wellBeing/stressStaeges.svg";


export const wellBeingRestBreakArticle = {
	id: "III. Well Being_2_5 How to get good quality rest: breaks",
	title: messageMap("restBreak.article.title", "learningOptimization"),
	description: messageMap("restBreak.article.description", "learningOptimization"),
	thumbnail: thumbnailAsset,
	thumbnailAlt: messageMap("restBreak.article.thumbnailAlt", "learningOptimization"),
	bodyFormatOrder: [
		"text1", "text2", "html1",
		"text3", "text4", "text5", "text6", "text7",
		"text8", "text9", "text10", "text11", "text12",
		"text13", "text14", "text15", "text16", "text17",
		"text18", "text19", "text20",
		"text21", "text22", "text23", "text24",
		"text25", "text26",
		"text27", "text28",
		
		"text29", "text30", "text31", "text32", "text33",
		"text43", "text35", "text36", "text37", "text83",
		"text39", "text40", "text41", "text42", "text43",
		"text44", "text45", "text46", "text47", "text48",
		"text49", "text50", "text51", "text52", "text53",
		"text54", "text55", "text56", "text57", "text58",
		"text59", "text60", "text61", "text62", "text63",
		"text64", "text65", "text66", "text67", "text68",
		"text69", "text70", "text71", "text72", "text73",
		"text74", "text75", "text76", "text77", "text78",
		"text79", "text80", "text81", "text82", "text83",
		
		"text84", "text85", "text86", "text87", "text88",
		"text89", "text90", "text91", "text92", "text93", "text94",
		"text95", "text96", "text97", "text98", "text99",
		"text100", "text101", "text102", "text103", "text104", "text105",
		
		"text106", "text107", "text108",
		"text109", "text110", "text111",
		"text112", "text113", "text114",
		"text115", "text116", "text117",
		"text118", "text119", "text120",
		"text121", "text122", "text123",

		"text124", "text125",
		
		"text126", "text127", "text128", "text129"
	],
	datePublished: "2022-03-06",
	dateModified: "2024-06-23"
};

export const wellBeingRestBreakArticleTexts = {
	text1: {
		text: messageMap("restBreak.texts.header1", "learningOptimization"),
		type: SUB_HEADER
	},
	text2: {
		text: messageMap("restBreak.texts.p1", "learningOptimization"),
		type: DESCRIPTION
	},
	text3: {
		text: messageMap("restBreak.texts.header2", "learningOptimization"),
		type: SUB_HEADER
	},
	text4: {
		text: messageMap("restBreak.texts.p2", "learningOptimization"),
		type: DESCRIPTION
	},
	text5: {
		text: messageMap("restBreak.texts.p3", "learningOptimization"),
		type: DESCRIPTION
	},
	text6: {
		text: messageMap("restBreak.texts.p4", "learningOptimization"),
		type: DESCRIPTION
	},
	text7: {
		text: messageMap("restBreak.texts.p5", "learningOptimization"),
		type: DESCRIPTION
	},
	text8: {
		text: messageMap("restBreak.texts.header3", "learningOptimization"),
		type: SUB_HEADER
	},
	text9: {
		text: messageMap("restBreak.texts.p6", "learningOptimization"),
		type: DESCRIPTION
	},
	text10: {
		text: messageMap("restBreak.texts.p7", "learningOptimization"),
		type: DESCRIPTION
	},
	text11: {
		text: messageMap("restBreak.texts.p8", "learningOptimization"),
		type: DESCRIPTION
	},
	text12: {
		text: messageMap("restBreak.texts.p9", "learningOptimization"),
		type: DESCRIPTION
	},
	text13: {
		text: messageMap("restBreak.texts.header4", "learningOptimization"),
		type: SUB_HEADER
	},
	text14: {
		text: messageMap("restBreak.texts.p10", "learningOptimization"),
		type: DESCRIPTION
	},
	text15: {
		text: messageMap("restBreak.texts.p11", "learningOptimization"),
		type: DESCRIPTION
	},
	text16: {
		text: messageMap("restBreak.texts.p12", "learningOptimization"),
		type: DESCRIPTION
	},
	text17: {
		text: messageMap("restBreak.texts.p13", "learningOptimization"),
		type: DESCRIPTION
	},
	text18: {
		text: messageMap("restBreak.texts.header5", "learningOptimization"),
		type: SUB_HEADER
	},
	text19: {
		text: messageMap("restBreak.texts.p14", "learningOptimization"),
		type: DESCRIPTION
	},
	text20: {
		text: messageMap("restBreak.texts.p15", "learningOptimization"),
		type: DESCRIPTION
	},
	text21: {
		text: messageMap("restBreak.texts.header6", "learningOptimization"),
		type: SUB_HEADER
	},
	text22: {
		text: messageMap("restBreak.texts.p16", "learningOptimization"),
		type: DESCRIPTION
	},
	text23: {
		text: messageMap("restBreak.texts.p17", "learningOptimization"),
		type: DESCRIPTION
	},
	text24: {
		text: messageMap("restBreak.texts.p18", "learningOptimization"),
		type: DESCRIPTION
	},
	text25: {
		text: messageMap("restBreak.texts.header7", "learningOptimization"),
		type: SUB_HEADER
	},
	text26: {
		text: messageMap("restBreak.texts.p19", "learningOptimization"),
		type: DESCRIPTION
	},
	text27: {
		text: messageMap("restBreak.texts.header8", "learningOptimization"),
		type: SUB_HEADER
	},
	text28: {
		text: messageMap("restBreak.texts.p20", "learningOptimization"),
		type: DESCRIPTION
	},
	text29: {
		text: messageMap("restBreak.texts.header9", "learningOptimization"),
		type: SUB_HEADER
	},
	text30: {
		text: messageMap("restBreak.texts.p21", "learningOptimization"),
		type: DESCRIPTION
	},
	text31: {
		text: messageMap("restBreak.texts.p22", "learningOptimization"),
		type: DESCRIPTION
	},
	text32: {
		text: messageMap("restBreak.texts.p23", "learningOptimization"),
		type: DESCRIPTION
	},
	text33: {
		text: messageMap("restBreak.texts.p24", "learningOptimization"),
		type: DESCRIPTION
	},
	text34: {
		text: messageMap("restBreak.texts.p25", "learningOptimization"),
		type: DESCRIPTION
	},
	text35: {
		text: messageMap("restBreak.texts.p26", "learningOptimization"),
		type: DESCRIPTION
	},
	text36: {
		text: messageMap("restBreak.texts.p27", "learningOptimization"),
		type: DESCRIPTION
	},
	text37: {
		text: messageMap("restBreak.texts.p28", "learningOptimization"),
		type: DESCRIPTION
	},
	text38: {
		text: messageMap("restBreak.texts.p29", "learningOptimization"),
		type: DESCRIPTION
	},
	text39: {
		text: messageMap("restBreak.texts.p30", "learningOptimization"),
		type: DESCRIPTION
	},
	text40: {
		text: messageMap("restBreak.texts.p31", "learningOptimization"),
		type: DESCRIPTION
	},
	text41: {
		text: messageMap("restBreak.texts.p32", "learningOptimization"),
		type: DESCRIPTION
	},
	text42: {
		text: messageMap("restBreak.texts.p33", "learningOptimization"),
		type: DESCRIPTION
	},
	text43: {
		text: messageMap("restBreak.texts.p34", "learningOptimization"),
		type: DESCRIPTION
	},
	text44: {
		text: messageMap("restBreak.texts.p35", "learningOptimization"),
		type: DESCRIPTION
	},
	text45: {
		text: messageMap("restBreak.texts.p36", "learningOptimization"),
		type: DESCRIPTION
	},
	text46: {
		text: messageMap("restBreak.texts.p37", "learningOptimization"),
		type: DESCRIPTION
	},
	text47: {
		text: messageMap("restBreak.texts.p38", "learningOptimization"),
		type: DESCRIPTION
	},
	text48: {
		text: messageMap("restBreak.texts.p39", "learningOptimization"),
		type: DESCRIPTION
	},
	text49: {
		text: messageMap("restBreak.texts.p40", "learningOptimization"),
		type: DESCRIPTION
	},
	text50: {
		text: messageMap("restBreak.texts.p41", "learningOptimization"),
		type: DESCRIPTION
	},
	text51: {
		text: messageMap("restBreak.texts.p42", "learningOptimization"),
		type: DESCRIPTION
	},
	text52: {
		text: messageMap("restBreak.texts.p43", "learningOptimization"),
		type: DESCRIPTION
	},
	text53: {
		text: messageMap("restBreak.texts.p44", "learningOptimization"),
		type: DESCRIPTION
	},
	text54: {
		text: messageMap("restBreak.texts.p45", "learningOptimization"),
		type: DESCRIPTION
	},
	text55: {
		text: messageMap("restBreak.texts.p46", "learningOptimization"),
		type: DESCRIPTION
	},
	text56: {
		text: messageMap("restBreak.texts.p47", "learningOptimization"),
		type: DESCRIPTION
	},
	text57: {
		text: messageMap("restBreak.texts.p48", "learningOptimization"),
		type: DESCRIPTION
	},
	text58: {
		text: messageMap("restBreak.texts.p49", "learningOptimization"),
		type: DESCRIPTION
	},
	text59: {
		text: messageMap("restBreak.texts.p50", "learningOptimization"),
		type: DESCRIPTION
	},
	text60: {
		text: messageMap("restBreak.texts.p51", "learningOptimization"),
		type: DESCRIPTION
	},
	text61: {
		text: messageMap("restBreak.texts.p52", "learningOptimization"),
		type: DESCRIPTION
	},
	text62: {
		text: messageMap("restBreak.texts.p53", "learningOptimization"),
		type: DESCRIPTION
	},
	text63: {
		text: messageMap("restBreak.texts.p54", "learningOptimization"),
		type: DESCRIPTION
	},
	text64: {
		text: messageMap("restBreak.texts.p55", "learningOptimization"),
		type: DESCRIPTION
	},
	text65: {
		text: messageMap("restBreak.texts.p56", "learningOptimization"),
		type: DESCRIPTION
	},
	text66: {
		text: messageMap("restBreak.texts.p57", "learningOptimization"),
		type: DESCRIPTION
	},
	text67: {
		text: messageMap("restBreak.texts.p58", "learningOptimization"),
		type: DESCRIPTION
	},
	text68: {
		text: messageMap("restBreak.texts.p59", "learningOptimization"),
		type: DESCRIPTION
	},
	text69: {
		text: messageMap("restBreak.texts.p60", "learningOptimization"),
		type: DESCRIPTION
	},
	text70: {
		text: messageMap("restBreak.texts.p61", "learningOptimization"),
		type: DESCRIPTION
	},
	text71: {
		text: messageMap("restBreak.texts.p62", "learningOptimization"),
		type: DESCRIPTION
	},
	text72: {
		text: messageMap("restBreak.texts.p63", "learningOptimization"),
		type: DESCRIPTION
	},
	text73: {
		text: messageMap("restBreak.texts.p64", "learningOptimization"),
		type: DESCRIPTION
	},
	text74: {
		text: messageMap("restBreak.texts.p65", "learningOptimization"),
		type: DESCRIPTION
	},
	text75: {
		text: messageMap("restBreak.texts.p66", "learningOptimization"),
		type: DESCRIPTION
	},
	text76: {
		text: messageMap("restBreak.texts.p67", "learningOptimization"),
		type: DESCRIPTION
	},
	text77: {
		text: messageMap("restBreak.texts.p68", "learningOptimization"),
		type: DESCRIPTION
	},
	text78: {
		text: messageMap("restBreak.texts.p69", "learningOptimization"),
		type: DESCRIPTION
	},
	text79: {
		text: messageMap("restBreak.texts.p70", "learningOptimization"),
		type: DESCRIPTION
	},
	text80: {
		text: messageMap("restBreak.texts.p71", "learningOptimization"),
		type: DESCRIPTION
	},
	text81: {
		text: messageMap("restBreak.texts.p72", "learningOptimization"),
		type: DESCRIPTION
	},
	text82: {
		text: messageMap("restBreak.texts.p73", "learningOptimization"),
		type: DESCRIPTION
	},
	text83: {
		text: messageMap("restBreak.texts.p74", "learningOptimization"),
		type: DESCRIPTION
	},
	text84: {
		text: messageMap("restBreak.texts.header10", "learningOptimization"),
		type: SUB_HEADER
	},
	text85: {
		text: messageMap("restBreak.texts.p75", "learningOptimization"),
		type: DESCRIPTION
	},
	text86: {
		text: messageMap("restBreak.texts.p76", "learningOptimization"),
		type: DESCRIPTION
	},
	text87: {
		text: messageMap("restBreak.texts.p77", "learningOptimization"),
		type: DESCRIPTION
	},
	text88: {
		text: messageMap("restBreak.texts.p78", "learningOptimization"),
		type: DESCRIPTION
	},
	text89: {
		text: messageMap("restBreak.texts.p79", "learningOptimization"),
		type: DESCRIPTION
	},
	text90: {
		text: messageMap("restBreak.texts.p80", "learningOptimization"),
		type: DESCRIPTION
	},
	text91: {
		text: messageMap("restBreak.texts.p81", "learningOptimization"),
		type: DESCRIPTION
	},
	text92: {
		text: messageMap("restBreak.texts.p82", "learningOptimization"),
		type: DESCRIPTION
	},
	text93: {
		text: messageMap("restBreak.texts.p83", "learningOptimization"),
		type: DESCRIPTION
	},
	text94: {
		text: messageMap("restBreak.texts.p84", "learningOptimization"),
		type: DESCRIPTION
	},
	text95: {
		text: messageMap("restBreak.texts.p85", "learningOptimization"),
		type: DESCRIPTION
	},
	text96: {
		text: messageMap("restBreak.texts.p86", "learningOptimization"),
		type: DESCRIPTION
	},
	text97: {
		text: messageMap("restBreak.texts.p87", "learningOptimization"),
		type: DESCRIPTION
	},
	text98: {
		text: messageMap("restBreak.texts.p88", "learningOptimization"),
		type: DESCRIPTION
	},
	text99: {
		text: messageMap("restBreak.texts.p89", "learningOptimization"),
		type: DESCRIPTION
	},
	text100: {
		text: messageMap("restBreak.texts.p90", "learningOptimization"),
		type: DESCRIPTION
	},
	text101: {
		text: messageMap("restBreak.texts.p91", "learningOptimization"),
		type: DESCRIPTION
	},
	text102: {
		text: messageMap("restBreak.texts.p92", "learningOptimization"),
		type: DESCRIPTION
	},
	text103: {
		text: messageMap("restBreak.texts.p93", "learningOptimization"),
		type: DESCRIPTION
	},
	text104: {
		text: messageMap("restBreak.texts.p94", "learningOptimization"),
		type: DESCRIPTION
	},
	text105: {
		text: messageMap("restBreak.texts.p95", "learningOptimization"),
		type: DESCRIPTION
	},
	text106: {
		text: messageMap("restBreak.texts.header11", "learningOptimization"),
		type: SUB_HEADER
	},
	text107: {
		text: messageMap("restBreak.texts.p96", "learningOptimization"),
		type: DESCRIPTION
	},
	text108: {
		text: messageMap("restBreak.texts.p97", "learningOptimization"),
		type: DESCRIPTION
	},
	text109: {
		text: messageMap("restBreak.texts.p98", "learningOptimization"),
		type: DESCRIPTION
	},
	text110: {
		text: messageMap("restBreak.texts.p99", "learningOptimization"),
		type: DESCRIPTION
	},
	text111: {
		text: messageMap("restBreak.texts.p100", "learningOptimization"),
		type: DESCRIPTION
	},
	text112: {
		text: messageMap("restBreak.texts.p101", "learningOptimization"),
		type: DESCRIPTION
	},
	text113: {
		text: messageMap("restBreak.texts.p102", "learningOptimization"),
		type: DESCRIPTION
	},
	text114: {
		text: messageMap("restBreak.texts.p103", "learningOptimization"),
		type: DESCRIPTION
	},
	text115: {
		text: messageMap("restBreak.texts.p104", "learningOptimization"),
		type: DESCRIPTION
	},
	text116: {
		text: messageMap("restBreak.texts.p105", "learningOptimization"),
		type: DESCRIPTION
	},
	text117: {
		text: messageMap("restBreak.texts.p106", "learningOptimization"),
		type: DESCRIPTION
	},
	text118: {
		text: messageMap("restBreak.texts.p107", "learningOptimization"),
		type: DESCRIPTION
	},
	text119: {
		text: messageMap("restBreak.texts.p108", "learningOptimization"),
		type: DESCRIPTION
	},
	text120: {
		text: messageMap("restBreak.texts.p109", "learningOptimization"),
		type: DESCRIPTION
	},
	text121: {
		text: messageMap("restBreak.texts.p110", "learningOptimization"),
		type: DESCRIPTION
	},
	text122: {
		text: messageMap("restBreak.texts.p111", "learningOptimization"),
		type: DESCRIPTION
	},
	text123: {
		text: messageMap("restBreak.texts.p112", "learningOptimization"),
		type: DESCRIPTION
	},
	text124: {
		text: messageMap("restBreak.texts.p113", "learningOptimization"),
		type: DESCRIPTION
	},
	text125: {
		text: messageMap("restBreak.texts.p114", "learningOptimization"),
		type: DESCRIPTION
	},
	text126: {
		text: messageMap("sourceHeader", "learningOptimization"),
		type: SOURCE_HEADER
	},
	text127: {
		text: messageMap("restBreak.sources.s1", "learningOptimization"),
		type: SOURCE
	},
	text128: {
		text: messageMap("restBreak.sources.s2", "learningOptimization"),
		type: SOURCE
	},
	text129: {
		text: messageMap("restBreak.sources.s3", "learningOptimization"),
		type: SOURCE
	}
};

export const wellBeingRestBreakArticleHTMLs = {
	html1: (
		<img key="stressStages" src={stressStagesAsset} alt="Stages of and types of stress" style={{width: "-webkit-fill-available"}} />
	)
};

